<template>

    <div class="newsletter-action__content__interaction__scroll-container">
        <div class="newsletter-action__content__padding-correction">
            <div class="newsletter-action__content__step newsletter-action__content__step__second-slide">

                <h2>{{ helpers.getTranslation(translations, 'preferences-intro-title') }}</h2>

                <div class="form-group slider-checkbox">

                    <input class="form-control slider-checkbox__input" id="newsletter-widget__festival" value="1" v-model="form.interests.festival" type="checkbox" name="checkbox_festival" >
                    <label class="slider-checkbox__label" for="newsletter-widget__festival">
                        <span>{{ helpers.getTranslation(translations, 'preferences-option1-title') }}</span>{{ helpers.getTranslation(translations, 'preferences-option1-description') }}
                    </label>

                </div>
                <div class="form-group slider-checkbox">

                    <input class="form-control slider-checkbox__input" id="newsletter-widget__business" title="" value="1" v-model="form.interests.business" type="checkbox" name="checkbox_partners">
                    <label class="slider-checkbox__label" for="newsletter-widget__business">
                        <span>{{ helpers.getTranslation(translations, 'preferences-option2-title') }}</span>{{ helpers.getTranslation(translations, 'preferences-option2-description') }}
                    </label>

                </div>
                <div class="form-group slider-checkbox">
                    <!-- TODO: CHECK IF THIS STILL WORKS AS THIS IS NOT SET IN MAILCHIMP. -->
                    <input class="form-control slider-checkbox__input" id="newsletter-widget__lichtkunst" title="" value="1" v-model="form.interests.lightart" type="checkbox" name="checkbox_lichtkunst">
                    <label class="slider-checkbox__label" for="newsletter-widget__lichtkunst">
                        <span>{{ helpers.getTranslation(translations, 'preferences-option3-title') }}</span>{{ helpers.getTranslation(translations, 'preferences-option3-description') }}
                    </label>

                    <span><p v-if="errors.interests && errors.interests.length" class="error-message" >{{ helpers.getTranslation(translations, errors.interests[0]) }}</p></span>

                </div>


                <button @click="persistPreferences()" v-bind:disabled="buttonClicked" class="btn btn-primary" v-bind:class="{ loading: buttonClicked }">{{ helpers.getTranslation(translations, 'preferences-submit') }} <span class="icon-arrow"><img src="/site/img/arrow_3.svg" alt=""></span><div class="lds-ring"><div></div><div></div><div></div><div></div></div></button>

            </div>
        </div>
    </div>

</template>

<script>
    import helpers from 'assets/js/site/helpers';
    import CookieMixin from './mixins/cookies'

    export default {

        mixins: [CookieMixin],

        data: function() {
            return {
                form: {
                    interests: {
                        festival: false,
                        business: false,
                        lightart: false,
                    },
                    email: this.email
                },
                helpers: helpers,
                errors: {},
                buttonClicked: false
            }
        },

        props: {
            email: { String, required: true },
            translations: { required: true }
        },

        methods: {
            persistPreferences: function()
            {
                this.buttonClicked = true;
                const self = this;

                axios.patch('/api/v1/newsletter/preferences', this.form).then(function (response) {
                    // Sets the cookie for a year which will be checked for in the CookieMixin.
                    // The computed property will be tested inside newsletter-root-component to indicate whether the subscribe options needs to be showed
                    // self.setCookie("newsletter-subscribed", true, 365);

                    self.$emit('change-component', { slide_name: 'thanks-for-subscribing'})

                }).catch(function (error) {
                    self.buttonClicked = false;

                    self.errors = error.response.data.errors;
                });
            }
        }
    }
</script>

<style lang="scss">
    .newsletter-action__content__step__second-slide {

        .form-group span {
            padding: 0;

            .error-message {
                font-size: .7em !important;
                margin: 1.5em 0 1.5em 0 !important;
            }
        }

        .slider-checkbox {
            margin-bottom: 38px;
        }
    }


</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/newsletter-widget/prefrences-slide.vue